import type { Token } from "../types";

/**
 * Procedural tree foliage is drawn once and recolored with a Pixi tint. Keep
 * color out of the structural signature so choosing a new shade cannot rebuild
 * thousands of leaf paths (or restart visibility work) on every picker event.
 */
export function tokenRenderSignature(tokens: Token[]): string {
  return JSON.stringify(tokens.map((token) => token.effect === "procedural-tree"
    ? { ...token, color: "__procedural-tree-tint__" }
    : token));
}

export function safePixiColor(value: string, fallback = "#4f7a3e"): string {
  return /^#[0-9a-f]{6}$/i.test(value) ? value : fallback;
}
